import { useLazyQuery } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import { READ_FAILED_SESSIONS } from 'graphql/queries/readFailedSessions';
import { useAuthStore } from 'stores/authStore';
import { useUiStore } from 'stores/uiStore';
import { Query, QueryReadFailedSessionsArgs } from 'types/generatedSchemaTypes';
import useIsLoggedIn from './useIsLoggedIn';

const useIsAccountRestricted = (checkRestrictedStateChange = false) => {
  const [modalShown, setModalShown] = useState(false);
  const isUserRestricted = useAuthStore((state) => state.accountRestricted);
  const isLoggedIn = useIsLoggedIn();
  const isStartupScreenOpen = useUiStore(
    (state) => state.isAppStartupScreenOpen
  );

  const [getFailedSessions] = useLazyQuery<Query, QueryReadFailedSessionsArgs>(
    READ_FAILED_SESSIONS,
    {
      fetchPolicy: 'cache-and-network',
      onCompleted({ readFailedSessions }) {
        useAuthStore
          .getState()
          .setAccountRestricted(readFailedSessions?.hasFailedSession ?? false);
      },
    }
  );

  //If user becomes restricted open the modal
  useEffect(() => {
    if (
      checkRestrictedStateChange &&
      isUserRestricted &&
      !modalShown &&
      !isStartupScreenOpen
    ) {
      setModalShown(true);
      useUiStore.getState().setSheetModal('accountRestricted');
    }
  }, [
    checkRestrictedStateChange,
    isUserRestricted,
    isStartupScreenOpen,
    modalShown,
  ]);

  const refetchFailedSessions = () => {
    if (isLoggedIn) {
      return getFailedSessions();
    }
  };

  return { refetchFailedSessions };
};

export default useIsAccountRestricted;
